import axios from 'axios';
import Constants from 'expo-constants';
import useApi from './api-hook';
import { MysteryShopperClient, PostalAddressDto } from '../api/api.g';
require('../models/helpers/string');

const useGoogleValidation = () => {
  const apiMysteryShopper = useApi(MysteryShopperClient);

  const validate = (data: PostalAddressDto, callback: (results: any) => void) => {
    apiMysteryShopper
      .validateAddress(data)
      .then((valid) => {
        callback(valid);
      })
      .catch(() => {
        callback(false);
      });
  };

  return validate;
};

export default useGoogleValidation;
